import React from 'react';
import { Lock } from 'lucide-react';
import { WhatsAppConversation } from '@/services/integrations/whatsappInboxService';
import { sessionWindowInfo } from '@/utils/whatsappInbox';

interface WindowStatusBannerProps {
  conversation: WhatsAppConversation;
  onChooseTemplate: () => void;
}

/** Shown above the composer when the 24h free-form window is closed —
 * guides the agent to a template instead of letting them try (and fail)
 * a free-form send. scope.txt §8: this is guidance, not the enforcement —
 * the backend still rejects a bare send-text regardless of what this shows. */
const WindowStatusBanner: React.FC<WindowStatusBannerProps> = ({ conversation, onChooseTemplate }) => {
  const win = sessionWindowInfo(conversation.last_inbound_at);
  if (win.open) return null;

  return (
    <div className="bg-white border-t border-gray-200 px-5 pt-3.5 pb-4">
      <div className="flex gap-3 p-3.5 rounded-lg bg-amber-50 border border-amber-200">
        <div className="w-8 h-8 flex-shrink-0 rounded-lg bg-amber-100 flex items-center justify-center">
          <Lock className="w-[17px] h-[17px] text-amber-700" />
        </div>
        <div className="flex-1">
          <div className="text-[13px] font-extrabold text-amber-800 mb-0.5">
            24-hour reply window {win.label}
          </div>
          <div className="text-[12.5px] leading-relaxed text-amber-900 max-w-2xl">
            Meta only allows free-form messages within 24 hours of the customer's last message.
            To reopen the conversation you must send an approved template — the customer's reply
            then reopens the window for another 24 hours.
          </div>
        </div>
        <button
          onClick={onChooseTemplate}
          className="self-center px-4 h-9 rounded-lg bg-[#153d23] text-white text-[12.5px] font-bold whitespace-nowrap flex-shrink-0 hover:opacity-90"
        >
          Choose a template
        </button>
      </div>
    </div>
  );
};

export default WindowStatusBanner;
